import { render, staticRenderFns } from "./template.html?vue&type=template&id=60980b36&scoped=true&"
import script from "./NaviSerchnaviLinkEn.vue?vue&type=script&lang=ts&"
export * from "./NaviSerchnaviLinkEn.vue?vue&type=script&lang=ts&"
import style0 from "./NaviSerchnaviLinkEn.vue?vue&type=style&index=0&id=60980b36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60980b36",
  null
  
)

export default component.exports